import { render, staticRenderFns } from "./YtoTableWithFullHeight.vue?vue&type=template&id=fbfee200&scoped=true"
import script from "./YtoTableWithFullHeight.vue?vue&type=script&lang=ts"
export * from "./YtoTableWithFullHeight.vue?vue&type=script&lang=ts"
import style0 from "./YtoTableWithFullHeight.vue?vue&type=style&index=0&id=fbfee200&prod&scoped=true&lang=less"
import style1 from "./YtoTableWithFullHeight.vue?vue&type=style&index=1&id=fbfee200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfee200",
  null
  
)

export default component.exports